import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Router} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { config } from '../../../../../environments/config';
import { tokenNotExpired } from 'angular2-jwt';
@Injectable()
export class UploadFilesMedicalCaseEventService {


public apiUrl = config.API_ROOT;
public headers: Headers = new Headers();
public options: RequestOptions;
public progress$: Observable<number>;
public progress: number;
public progressObserver: any;

constructor(
    public http: Http,
    public router: Router
    ) {
        this.progress = 0;
        if (tokenNotExpired()) {
            this.headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
        }
        this.options = new RequestOptions({ headers: this.headers });
        this.progress$ = new Observable(observer => {
            this.progressObserver = observer;
        });
    }

    public getAttachmentDocuments(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (id !== null && id !== undefined) {
            params.append('id', String(id));
        }

        const options = new RequestOptions({search: params, headers: this.headers});

        return this.http.get( `${this.apiUrl}/documents-medical-case/${id}/download-attachment`, options);
    }

    public updateAttachmentDocument(files: File[], id: number): Observable<Response> {
        const url = `${this.apiUrl}/documents-medical-case/${id}/attachment`;
        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file', files[i], files[i].name);
        }
        return this.http.post(url, formData, this.options);
    }

    public getAttachmentDocument(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (id !== null && id !== undefined) {
            params.append('id', String(id));
        }

        const options = new RequestOptions({search: params, headers: this.headers});

        return this.http.get( `${this.apiUrl}/documents-medical-case/${id}/download-attachment`, options);
    }

    // public updateAttachmentDocumentProfileSurvey(files: File[], id:number, candidate_id: number, list_profile_survey_id: number): Observable<Response> {
    //     let url = `${this.apiUrl}/documents-medical-case/`;

    //     const formData: FormData = new FormData();
    //     for (let i = 0; i < files.length; i++) {
    //         formData.append('file', files[i], files[i].name);
    //         formData.append('candidate_id', candidate_id.toString());
    //         // formData.append('profile_survey_id', profile_survey_id.toString());
    //         // formData.append('checklist_profile_survey_id', checklist_profile_survey_id.toString());
    //         formData.append('list_profile_survey_id', list_profile_survey_id.toString());
    //         // if(radication_id !== null && radication_id !== undefined)
    //         //     formData.append('radication_id', radication_id.toString());
    //     }

    //     // if (id) {
    //     //     url = `${this.apiUrl}/document-profile-surveis/${id}/attachment`;
    //     // }

    //     return this.http.post(url, formData, this.options);
    // }
    public addAttachmentDocument(files: File[], candidate_id: number, medical_case_event_doc_type_id: number): Observable<Response> {
        let url = `${this.apiUrl}/documents-medical-case/`;

        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('files[]', files[i], files[i].name);
        }
        formData.append('medical_case_event_id', candidate_id.toString());
        formData.append('medical_case_event_doc_type_id', medical_case_event_doc_type_id.toString());

        return this.http.post(url, formData, this.options);
    }

    public deleteAttachmentDocument(id:number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/documents-medical-case/${id}`, { headers: this.headers } );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/medical-cases-event/upload-files-medical-case-event.service.ts